import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.333 20h33.334M3.333 20c0 9.205 7.462 16.667 16.667 16.667M3.333 20c0-9.205 7.462-16.667 16.667-16.667M36.667 20c0 9.205-7.462 16.667-16.667 16.667M36.667 20c0-9.205-7.462-16.667-16.667-16.667m0 0A25.5 25.5 0 0 1 26.667 20 25.5 25.5 0 0 1 20 36.667m0-33.334A25.5 25.5 0 0 0 13.333 20 25.5 25.5 0 0 0 20 36.667",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }